import React from "react";
import { toHashPath } from "../routes/hashRouting";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      {/* Google AdSense — Leaderboard before footer */}
      <div className="container" style={{ paddingBottom: "28px" }}>
        <div
          className="ad-slot ad-slot-leaderboard"
          aria-label="Advertisement"
        >
          <span>Advertisement</span>
          <span className="ad-slot-label">728×90 Leaderboard</span>
          {/* Replace with AdSense code:
          <ins className="adsbygoogle"
            style={{display:'block'}}
            data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"
            data-ad-slot="XXXXXXXXXX"
            data-ad-format="auto"
            data-full-width-responsive="true" />
          */}
        </div>
      </div>

      <div className="container">
        <div className="footer-grid">
          {/* Brand col */}
          <div>
            <div className="footer-brand-name">
              Calculate<span>yourtax</span>.in
            </div>
            <p className="footer-tagline">
              India's free income tax calculator. Compare old vs new regime for
              FY 2024-25, 2025-26, and 2026-27. Always verify with a Chartered
              Accountant for your final figures.
            </p>
          </div>

          {/* Links */}
          <div>
            <div className="footer-col-title">Explore</div>
            <div className="footer-links">
              <a href={toHashPath("/home")}>Home</a>
              <a href={toHashPath("/home/howto")}>How to Use</a>
              <a href={toHashPath("/guides")}>Tax Guides</a>
              <a href={toHashPath("/tools")}>Tax Tools</a>
              <a href={toHashPath("/updates")}>Budget Updates</a>
            </div>
          </div>

          {/* Help */}
          <div>
            <div className="footer-col-title">Help & Info</div>
            <div className="footer-links">
              <a href={toHashPath("/home/faq")}>FAQ</a>
              <a href={toHashPath("/home/howto")}>How to Calculate Tax</a>
              <a href={toHashPath("/home")}>Privacy Policy</a>
              <a href={toHashPath("/home")}>Contact Us</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div>© {year} Calculateyourtax.in — All rights reserved</div>
          <div className="footer-mini-links">
            <a href={toHashPath("/home")}>Privacy</a>
            <a href={toHashPath("/home")}>Disclaimer</a>
            <a href={toHashPath("/home")}>Contact</a>
          </div>
        </div>
      </div>

      <div className="footer-disclaimer">
        <div className="container">
          This tool provides estimates only and is not a substitute for professional tax advice.
          Tax laws change frequently — always verify with the Income Tax Department or a qualified CA.
        </div>
      </div>
    </footer>
  );
}
